import React from 'react';
import { useWebinar } from '../../hooks/useWebinar';
import { CommandCenter } from './CommandCenter';
import { SessionCard } from './SessionCard';
export function WebinarHero() {
  const {
    copy
  } = useWebinar();
  const c = copy.hero;
  return <section aria-labelledby="webinar-title" className="relative bg-[#070A1C] pt-[72px] overflow-hidden" data-id="element-7905" data-mp="h54hnm9vc54x">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 pt-16 md:pt-24 pb-20 md:pb-28 grid grid-cols-1 lg:grid-cols-[1.05fr_1fr] gap-14 lg:gap-16 items-center" data-id="element-7906" data-mp="m6k2pec1qbnb">
        <div data-id="element-7907" data-mp="c7baapwtx532">
          <p className="font-sans text-[11.5px] font-semibold tracking-[0.2em] uppercase text-[#A5A1FF]" data-id="element-7908" data-mp="c7uihewogf3w">{c.eyebrow}</p>
          <h1 id="webinar-title" className="mt-6 font-serif text-[2.6rem] sm:text-[3.2rem] lg:text-[3.9rem] leading-[1.04] tracking-tight text-white" data-id="element-7909" data-mp="3ui6678vmw49i">
            {c.titleLead}
            <span className="block text-[#A5A1FF] [text-shadow:0_0_36px_rgba(99,91,255,0.55)]" data-id="element-7910" data-mp="3kmmobqdwn63r">{c.titleAccent}</span>
          </h1>
          <p className="mt-7 font-serif text-[1.35rem] md:text-[1.5rem] leading-snug text-white/90" data-id="element-7911" data-mp="3pn0mmgppf1ol">{c.promise}</p>
          <p className="mt-5 max-w-[34rem] font-sans text-[16px] leading-relaxed text-[#A6ABC8]" data-id="element-7912" data-mp="1jrhkic9ua29r">{c.body}</p>

          <SessionCard data-id="element-7913" data-mp="1xrsf9qe9s107" />
          <p className="mt-4 font-sans text-[13px] text-[#8A90B2]" data-id="element-7914" data-mp="1xq8yzzsm5pyf">{c.micro}</p>
        </div>

        <CommandCenter data-id="element-7915" data-mp="1tqqe340slevl" />
      </div>
    </section>;
}